import { Component, DestroyRef, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { finalize } from "rxjs";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { DialogHeaderComponent } from "../../../../shared/components/dialog-header/dialog-header.component";
import { MarketingApiService } from "../../../services/marketing/marketing-api.service";
import {
  MarketingIntegration,
  MarketingProvider,
} from "../../../services/marketing/marketing.models";

export interface EventRegistrationEditorData {
  eventId: number;
  provider: MarketingProvider;
  integration?: MarketingIntegration;
}

@Component({
  selector: "app-event-registration-editor",
  imports: [FormsModule, ButtonComponent, DialogHeaderComponent],
  templateUrl: "./event-registration-editor.component.html",
  styleUrl: "./event-registration-editor.component.scss",
})
export class EventRegistrationEditorComponent {
  readonly data = inject<EventRegistrationEditorData>(MAT_DIALOG_DATA);
  private readonly api = inject(MarketingApiService);
  private readonly dialog = inject(
    MatDialogRef<EventRegistrationEditorComponent>,
  );
  private readonly destroyRef = inject(DestroyRef);
  private readonly retryKey = crypto.randomUUID();
  readonly providerName =
    this.data.provider === "meta" ? "Meta Ads" : "Google Ads";
  name = this.data.integration?.display_name || "";
  pixelId = this.data.integration?.public_configuration["pixel_id"] || "";
  conversionId =
    this.data.integration?.public_configuration["conversion_id"] || "";
  conversionLabel =
    this.data.integration?.public_configuration["conversion_label"] || "";
  busy = false;
  error = "";

  save() {
    if (this.busy || !this.name.trim()) return;
    const existing = this.data.integration;
    const body = {
      provider: this.data.provider,
      display_name: this.name.trim(),
      public_configuration:
        this.data.provider === "meta"
          ? { pixel_id: this.pixelId }
          : {
              conversion_id: this.conversionId,
              conversion_label: this.conversionLabel,
            },
      enabled: existing?.enabled || false,
      ...(existing ? { lock_version: existing.lock_version } : {}),
    };
    this.busy = true;
    this.error = "";
    this.api
      .saveEventRegistration(
        this.data.eventId,
        body,
        existing?.id,
        this.retryKey,
      )
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => (this.busy = false)),
      )
      .subscribe({
        next: (record) => this.dialog.close(record),
        error: (error) => {
          this.error =
            error?.error?.code === "invalid_destination"
              ? "Confira o formato do Pixel ID ou do Conversion ID e label."
              : error?.status === 409
                ? "O cadastro foi alterado por outra pessoa. Feche e recarregue antes de editar novamente."
                : "Não foi possível salvar. Verifique seu acesso ao evento e os dados informados.";
        },
      });
  }

  close() {
    if (!this.busy) this.dialog.close();
  }
}
